module.exports = __webpack_public_path__ + "img/bubble.fe0c9cfb.png";